<div class="footer d-md-block d-flex justify-content-center">
  <hr class="mb-2 d-none d-md-block">
  <p class="text-md-start text-center my-1 my-md-0">
    Bayport Colombia S.A., 2025,<br />Todos los derechos reservados<br /><span
      class="d-none d-md-flex">V.{{ version }}</span>
  </p>
</div>
